import { inject, Injectable } from '@angular/core';

import { SuggestedUserStoreActions, UserStoreActions, UserStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { environment } from '@rocksoft/environment';
import { EnvironmentFeatures } from '@rocksoft/shared';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { combineLatest, Observable, of } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserResolver {
  private readonly store = inject(Store);
  private readonly features: EnvironmentFeatures = environment.features;
  private readonly authorizationService = inject(AuthorizationService);

  resolve(): Observable<boolean> {
    if (!this.features.security?.enabled) {
      return of(true);
    }

    const usersLoaded$ = this.store.select(UserStoreSelectors.selectUsersLoaded);
    const listUsersAuthorized$ = this.authorizationService.getIsAuthorized$(Permissions.SecurityListUsers);
    const listSuggestedUsersAuthorized$ = this.authorizationService.getIsAuthorized$(
      Permissions.SecurityListAzureUsers
    );

    return combineLatest([usersLoaded$, listUsersAuthorized$, listSuggestedUsersAuthorized$]).pipe(
      tap(([loaded, listUsersAuthorized, listSuggestedUsersAuthorized]) => {
        const shouldRequest = !loaded && listUsersAuthorized && listSuggestedUsersAuthorized;
        if (shouldRequest) {
          this.store.dispatch(UserStoreActions.UserResolverActions.usersRequested());
          this.store.dispatch(SuggestedUserStoreActions.UserResolverActions.suggestedUsersRequested());
        }
      }),
      map(([loaded]) => loaded),
      first()
    );
  }
}
